/**
 * Valida el formulario de boletos.
 * @param {Object} formData - Datos del formulario.
 * @returns {Record<string, string>} Errores por campo.
 */
export const validateLotTicket = (formData = {}) => {
  const errors = {};

  const requiredFields = [
    'uuid_country',
    'uuid_province',
    'uuid_department',
    'uuid_district',
    'uuid_marital_status',
    'uuid_nationality',
    'full_name',
    'ticket_number',
    'dni',
    'address',
    'postal_code',
    'birth_date',
    'gender',
    'details',
  ];

  requiredFields.forEach((field) => {
    if (!formData[field] || String(formData[field]).trim() === '') {
      errors[field] = 'Campo obligatorio';
    }
  });

  return errors;
};
